import React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectButton, DropdownLight } from '@weezevent/nacre';

import css from './pagination-dropdown.module.css';

const PaginationDropDown = ({
    title,
    tooltip,
    label,
    count,
    selected = [],
    disabled = false,
    loading = false,
    limit,
    onChange,
    pageSizes = [50, 100, 250, 500],
    displaySelect = true,
    displayDropdown = true,
    items
}) => {
    const { t } = useTranslation();

    const resolvedTitle = React.useMemo(() => {
        if (!selected.length > 0) {
            return t('common.action');
        }
        return title;
    }, [selected, title]);

    const pageSizesOptions = React.useMemo(() => {
        return pageSizes.map((value, key) => ({ key, label: t(label, { count: value }), value }));
    }, [pageSizes, label]);

    const display = React.useMemo(() => {
        return displayDropdown && !loading && count >= Math.min.apply(Math, pageSizes);
    }, [loading, pageSizes, count]);

    if (!displayDropdown && !displaySelect) {
        return null;
    }

    return (
        <div className={css['pagination-dropdown']}>
            <div className={css['pagination-dropdown-block']}>
                {displaySelect && (
                    <SelectButton tooltipTitle={tooltip} title={resolvedTitle} objects={selected} disabled={disabled}>
                        {items}
                    </SelectButton>
                )}
            </div>
            <div className={css['pagination-dropdown-block']}>
                {display && <DropdownLight position={'bottom-end'} className={css['dropdown-pagesize']} value={limit} onChange={onChange} items={pageSizesOptions} />}
            </div>
        </div>
    );
};

export default PaginationDropDown;
